var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDelivery = function SvgDelivery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#3B3F44",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#delivery_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.572 3.428H7.429c-.631 0-1.143.512-1.143 1.143v5.143c0 .631.512 1.143 1.143 1.143h5.143c.63 0 1.143-.512 1.143-1.143V4.57c0-.631-.512-1.143-1.143-1.143M4.572 13.714h8.697c.3.002.587.12.8.332l1.36 1.383M.572.571h1.142a1.143 1.143 0 0 1 1.143 1.143v9.714M4.572 13.428q.008.142 0 .286a1.989 1.989 0 1 1 0-.286M9.714 8h1.143"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "delivery_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgDelivery;